/** Where getRoute actually took the geometry from — not the requested rebuildType. */
export enum RouteRebuildSourceEnum {
  FromCache = "FromCache",
  FromMlPath = "FromMlPath",
  LiveWithoutCache = "LiveWithoutCache",
  LiveCacheUpdated = "LiveCacheUpdated",
}
